// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyramais-table .ant-table-content .ant-table-thead .ant-table-cell {
  color: #a8a8a8 !important;
  background-color: #f2f2f2 !important;
  font-weight: 600;
  padding: 0.812rem 1rem !important;
  font-size: 0.875rem;
}
.gyramais-table .ant-table-content .ant-table-thead .ant-table-cell:first-child {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.gyramais-table .ant-table-content .ant-table-thead .ant-table-cell:last-child {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.gyramais-table .ant-table-content .ant-table-thead .ant-table-cell::before {
  display: none;
}
.gyramais-table .ant-table-content .ant-table-tbody .ant-table-cell {
  font-size: 1rem;
  padding-left: 1rem;
  text-transform: uppercase;
  font-weight: 600;
  color: #000000;
}
.gyramais-table .ant-table-content::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}
.gyramais-table .ant-table-content::-webkit-scrollbar-track {
  background: transparent;
}
.gyramais-table .ant-table-content::-webkit-scrollbar-thumb {
  background: #dcdcdc;
  border-radius: 0.625rem;
}
.gyramais-table .ant-table-content::-webkit-scrollbar-thumb:hover {
  background: #aeaeae;
}
.gyramais-table .ant-pagination-item {
  border-radius: 0.5rem;
}
.gyramais-table .ant-pagination-item-active {
  border-color: var(--primary-color);
}
.gyramais-table .ant-pagination-item-active a {
  color: var(--primary-color);
}
.gyramais-table .ant-pagination-item-link {
  border-radius: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/gyramais/Table/styles.less"],"names":[],"mappings":"AAAA;EAIQ,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;AAFR;AAIQ;EACE,+BAAA;EACA,kCAAA;AAFV;AAKQ;EACE,gCAAA;EACA,mCAAA;AAHV;AAMQ;EACE,aAAA;AAJV;AAjBA;EA4BQ,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AARR;AAYI;EACE,aAAA;EACA,cAAA;AAVN;AAaI;EACE,uBAAA;AAXN;AAcI;EACE,mBAAA;EACA,uBAAA;AAZN;AAeI;EACE,mBAAA;AAbN;AAtCA;EAwDI,qBAAA;AAfJ;AAzCA;EA4DI,kCAAA;AAhBJ;AA5CA;EA+DM,2BAAA;AAhBN;AA/CA;EAoEI,qBAAA;AAlBJ","sourcesContent":[".gyramais-table {\n  .ant-table-content {\n    .ant-table-thead {\n      .ant-table-cell {\n        color: #a8a8a8 !important;\n        background-color: #f2f2f2 !important;\n        font-weight: 600;\n        padding: 0.812rem 1rem !important;\n        font-size: 0.875rem;\n\n        &:first-child {\n          border-top-left-radius: 0.75rem;\n          border-bottom-left-radius: 0.75rem;\n        }\n\n        &:last-child {\n          border-top-right-radius: 0.75rem;\n          border-bottom-right-radius: 0.75rem;\n        }\n\n        &::before {\n          display: none;\n        }\n      }\n    }\n\n    .ant-table-tbody {\n      .ant-table-cell {\n        font-size: 1rem;\n        padding-left: 1rem;\n        text-transform: uppercase;\n        font-weight: 600;\n        color: #000000;\n      }\n    }\n\n    &::-webkit-scrollbar {\n      width: 0.5rem;\n      height: 0.5rem;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #dcdcdc;\n      border-radius: 0.625rem;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background: #aeaeae;\n    }\n  }\n\n  .ant-pagination-item {\n    border-radius: 0.5rem;\n  }\n\n  .ant-pagination-item-active {\n    border-color: var(--primary-color);\n\n    a {\n      color: var(--primary-color);\n    }\n  }\n\n  .ant-pagination-item-link {\n    border-radius: 0.5rem;\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
